import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { Link } from "react-router-dom";

export function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem("cookie-consent", "all");
    setShowBanner(false);
  };

  const acceptNecessary = () => {
    localStorage.setItem("cookie-consent", "necessary");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-3 left-3 right-3 z-40 sm:bottom-5 sm:left-auto sm:right-5 sm:max-w-md">
      <div className="rounded-lg border bg-background p-3 shadow-xl sm:p-4">
        <div className="flex gap-3">
          <div className="min-w-0 flex-1">
            <h3 className="font-semibold">Cookies og privatliv</h3>
            <p className="mt-1 text-sm leading-5 text-muted-foreground">
              Vi bruger nødvendige cookies til login og funktionelle cookies til præferencer.{" "}
              <Link to="/privacy-policy" className="underline hover:text-primary">
                Læs mere
              </Link>
            </p>
          </div>
          <Button variant="ghost" size="icon" onClick={acceptNecessary} className="h-8 w-8 flex-shrink-0" aria-label="Luk cookiebesked">
            <X className="h-4 w-4" />
          </Button>
        </div>
          
          <div className="mt-3 flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={acceptNecessary}
              className="flex-1 whitespace-nowrap"
            >
              Kun nødvendige
            </Button>
            <Button
              size="sm"
              onClick={acceptAll}
              className="flex-1 whitespace-nowrap"
            >
              Acceptér alle
            </Button>
          </div>
      </div>
    </div>
  );
}
